module.exports = __webpack_public_path__ + "static/img/son14_active.c3b82f1e.png";